export default __webpack_public_path__ + "static/media/black_and_white_transparent_inverted_version.e52f46b3.svg";